import { MapPinIcon } from '@heroicons/react/20/solid';

function HelpScreen() {
  return (
    <div className="mt-2 text-left">
      <h2>Help</h2>
      <dl className="grid max-w-xl grid-cols-1 gap-x-8 gap-y-10 lg:max-w-none lg:grid-cols-2 lg:gap-y-16">
        <div className="relative pl-16">
          <dt className="text-mt-ink text-base leading-7 font-semibold">
            <div className="mt-btn bg-mt-primary absolute top-0 left-0 flex h-10 w-10 items-center justify-center rounded-lg">
              <MapPinIcon className="h-6 w-6 text-white" aria-hidden="true" />
            </div>
            Map Overview
          </dt>
          <dd className="text-mt-ink-muted mt-2 text-base leading-7">
            <ul>
              <li>
                <b>Red Pin:</b> This is your current location. Move around to
                explore the trail and find points of interest.
              </li>
              <li>
                <b> Checkmark Pin:</b> These represent locations or tasks you've
                successfully scanned or completed. Congratulations!
              </li>
              <li>
                <b>Other Pins:</b> These are points of interest or tasks waiting
                for your discovery.
              </li>
            </ul>
          </dd>
          <dt className="text-mt-ink text-base leading-7 font-semibold">
            <div className="mt-btn bg-mt-primary absolute top-0 left-0 flex h-10 w-10 items-center justify-center rounded-lg">
              <MapPinIcon className="h-6 w-6 text-white" aria-hidden="true" />
            </div>
            Map Overview
          </dt>
          <dd className="text-mt-ink-muted mt-2 text-base leading-7">
            <ul>
              <li>
                <b>Red Pin:</b> This is your current location. Move around to
                explore the trail and find points of interest.
              </li>
              <li>
                <b> Checkmark Pin:</b> These represent locations or tasks you've
                successfully scanned or completed. Congratulations!
              </li>
              <li>
                <b>Other Pins:</b> These are points of interest or tasks waiting
                for your discovery.
              </li>
            </ul>
          </dd>
        </div>
      </dl>
    </div>
  );
}

export default HelpScreen;
